var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowtop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_12_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66326 18.2305L7.64673 3.69934C7.64647 3.46367 7.45533 3.27285 7.21969 3.27293C7.00934 3.27302 6.83258 3.42689 6.7832 3.63141C6.58346 4.45844 6.14913 5.21331 5.52886 5.80321L2.79204 8.53996L1.65601 7.40395L8.47231 0.587887L15.2714 7.38674L14.1353 8.52275L11.4845 5.87203C10.824 5.27871 10.3679 4.49612 10.1749 3.63597C10.1265 3.42037 9.94223 3.25581 9.72132 3.25581C9.47831 3.25581 9.28129 3.45274 9.28129 3.69583L9.28145 18.2303L7.66326 18.2305Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.94,
    height: 14.69,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.850098 18.4805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowtop);
export default __webpack_public_path__ + "static/media/arrowtop.ebe475a88bc2958ef9a5e14861d7ca78.svg";
export { ForwardRef as ReactComponent };